import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';

export interface IBreadcrumbProps extends IBaseElementProps {
	links?: ILink[];
}

/**
 * Breadcrumb
 * @block
 * @requiresHooks
 * @icon ellipsis
 */
const Breadcrumb: React.FC<IBreadcrumbProps> = ({
	className,
	classNames = [],
	links = [],
}) => (
	<nav
		aria-label="breadcrumb"
		className={className || cn('breadcrumb-container', ...classNames)}
	>
		<ol className="breadcrumb">
			{links.map((link, index) =>
				index === links.length - 1 ? (
					<li
						key={`${index}-${link.href}`}
						className={cn('breadcrumb-item')}
						aria-current="page"
					>
						{link.label}
					</li>
				) : (
					<li
						key={`${index}-${link.href}`}
						className={cn('breadcrumb-item')}
					>
						<Button {...link} className="breadcrumb-item-link" />
					</li>
				),
			)}
		</ol>
	</nav>
);

export default Breadcrumb;
